import React, {useEffect, useMemo} from 'react'
import {Redirect, Route, Switch, useHistory,} from "react-router-dom";
import SighupSupplierWizard from "./components/signupSupplier/SignupSupplierWizard";
import Schedule from "./components/schedule/Schedule";
import {connect} from "react-redux";
import PersonalDetails from "./components/PersonalDetails";
import BookingWizard from "./components/bookingWizard/BookingWizard";
import LoginPage from "./components/LoginPage";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {AUTH_SUCCESSFUL, LOGOUT} from "./store/action";
import CircularProgress from "@material-ui/core/CircularProgress";
import Box from "@material-ui/core/Box";
import Homepage from "./components/Homepage";
import PayPage from "./PayPage";
import SignupLandingPage from "./components/SignupLandingPage";
import TermsAndConditions from "./components/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ContactUs from './components/ContactUs';
import AuthControl from './components/reduxFormComponents/AuthControl';
import { getSubdomain } from './utils/getSubdomain';

const useAuthGuard = ({dispatch}) => {
    const history = useHistory();
    useEffect(() => {
        firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                user.getIdToken(true).then(authToken => {
                    dispatch({type: AUTH_SUCCESSFUL, payload: authToken})
                })
            } else {
                dispatch({type: LOGOUT})
                history.push('/login')
            }
        });
    }, [history,dispatch])
}

const PrivateRouteDump = ({children, auth, dispatch, ...rest}) => {
    useAuthGuard({dispatch})
    if (auth === null) {
        return <Box flex={1} display={'flex'} alignItems={'center'}><CircularProgress color="primary"/></Box>
    }
    return (
        <Route
            {...rest}
            render={({location}) =>
                auth ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: {from: location}
                        }}
                    />
                )
            }
        />
    );
}
const mapStateToProps = state => ({
    auth: state.general.auth
})
const PrivateRoute = connect(mapStateToProps)(PrivateRouteDump)

const Routes = ({auth}) => {
    const subdomain = useMemo(()=>getSubdomain(),[])
    if(subdomain){
        return <BookingWizard isAdmin={false}/>
    }
    return (
        <Switch>
            <Route path="/signup-supplier">
                <AuthControl />
            </Route>
            <Route path="/signup">
                <SignupLandingPage />
            </Route>
            <Route path="/s/:shortHash">
                <BookingWizard isAdmin={false}/>
            </Route>
            <PrivateRoute path="/personal-details">
                <PersonalDetails/>
            </PrivateRoute>
            <PrivateRoute path="/edit-supplier">
                <SighupSupplierWizard editMode={true}/>
            </PrivateRoute>
            <PrivateRoute path="/calendar">
                <Schedule isAdmin={true}/>
            </PrivateRoute>
            <PrivateRoute path="/pay">
                <PayPage isAdmin={true}/>
            </PrivateRoute>
            <Route path="/login">
                <LoginPage/>
            </Route>
            <Route path="/terms">
                <TermsAndConditions />
            </Route>
            <Route path="/privacy">
                <PrivacyPolicy />
            </Route>
            <Route path="/contact">
                <ContactUs />
            </Route>
            <Route path="/">
                {auth && <Redirect to={{
                    pathname: "/calendar",
                }}/>}
                <Homepage />
            </Route>
        </Switch>
    )
}
const mapStateToPropsRoutes = state => ({
    auth: state.general.auth
})
export default connect(mapStateToPropsRoutes)(Routes)